import {Component, OnInit, Input, AfterViewInit, Output, EventEmitter, OnChanges} from '@angular/core';

declare var jquery:any;
declare var $ :any;

@Component({
    selector: 'app-report-list-button',
    templateUrl: './report-list-button.component.html',
    styleUrls: ['./report-list-button.component.css']
})
export class ReportListButtonComponent implements OnInit ,AfterViewInit, OnChanges{

    @Input() reports:any;
    @Output() onSwitchReport = new EventEmitter<any>();
    isExpand:boolean;

    test:string;
    constructor() { }

    ngOnInit() {
        this.isExpand = false;
    }

    ngOnChanges() {
        let reportsListLength = this.reports.length;
        for(let i=0;i<reportsListLength;i++){
            this.reports[i].nameHtml = this.reports[i].name.substr(0,2)+'<br/>'+this.reports[i].name.substr(2,3);
        }
    }

    ngAfterViewInit(){

    }

    onClick(){
        $(".casePracticeBtn").each(function(index){
                this.style.transition = "top 0.5s";
        });
        if(this.isExpand){
            $(".casePracticeBtn").each(function(index) {
                this.style.top = "0.3rem";
            });
        }
        else{
            $(".casePracticeBtn").each(function(index){
                if (index == 0) {
                    this.style.top = "1.56rem";
                }
                else if (index == 1) {
                    this.style.top = "2.86rem";
                }
                else if (index == 2) {
                    this.style.top = "4.14rem";
                }
                else if (index == 3) {
                    this.style.top = "5.42rem";
                }
                else if (index == 4) {
                    this.style.top = "6.7rem";
                }
            });
        }

        this.isExpand = !this.isExpand;
    }

    switchReport(id, type, index) {
        window.scrollTo(0,0);
        //document.documentElement.scrollTop = 0;
        $(".casePracticeBtn").each(function(index){
            this.style.transition = "top 0s";
        });
        this.onSwitchReport.emit({id: id, type: type, index: index});
        $(".casePracticeBtn").each(function(index){
                this.style.top = "0.3rem";
        });
        this.isExpand=!this.isExpand;
    }
}



// WEBPACK FOOTER //
// ./src/app/report-list-button/report-list-button.component.ts